import { render, staticRenderFns } from "./Avisos.backup.vue?vue&type=template&id=2f6dd494&scoped=true"
import script from "./Avisos.backup.vue?vue&type=script&lang=js"
export * from "./Avisos.backup.vue?vue&type=script&lang=js"
import style0 from "./Avisos.backup.vue?vue&type=style&index=0&id=2f6dd494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6dd494",
  null
  
)

export default component.exports